export enum EnterPhoneNumberResponses {
  DEFAULT,
  BACK,
  NEXT,
  LIMIT,
}
